var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReelPostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#313131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "url(#paint0_radial_3649_58882)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 3.60156H6.08261C6.03652 3.60156 5.99102 3.60274 5.94611 3.6057C5.90829 3.59979 5.8687 3.60156 5.83088 3.61456C4.57934 3.74102 3.59961 4.80052 3.59961 6.08456V8.91797C3.59961 10.2871 4.71347 11.401 6.08261 11.401H8.91602C10.2852 11.401 11.3996 10.2871 11.3996 8.91797V6.08456C11.3996 4.71543 10.2857 3.60156 8.91602 3.60156ZM10.8394 5.50429H9.22802L8.39247 4.07547H8.91661C9.82247 4.07547 10.5901 4.6782 10.84 5.50429H10.8394ZM7.15688 5.50429L6.32134 4.07547H7.84293L8.67847 5.50429H7.15688V5.50429ZM5.78479 4.09793L6.60734 5.50429H4.15979C4.38138 4.77097 5.01188 4.21315 5.78479 4.09793V4.09793ZM10.9251 8.91797C10.9251 10.0253 10.0234 10.9271 8.91602 10.9271H6.08261C4.97525 10.9271 4.07411 10.0259 4.07411 8.91797V6.08456C4.07411 6.04911 4.07529 6.01365 4.07706 5.97879H10.9227C10.9245 6.01365 10.9257 6.04911 10.9257 6.08456V8.91797H10.9251Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 3.60156H6.08261C6.03652 3.60156 5.99102 3.60274 5.94611 3.6057C5.90829 3.59979 5.8687 3.60156 5.83088 3.61456C4.57934 3.74102 3.59961 4.80052 3.59961 6.08456V8.91797C3.59961 10.2871 4.71347 11.401 6.08261 11.401H8.91602C10.2852 11.401 11.3996 10.2871 11.3996 8.91797V6.08456C11.3996 4.71543 10.2857 3.60156 8.91602 3.60156ZM10.8394 5.50429H9.22802L8.39247 4.07547H8.91661C9.82247 4.07547 10.5901 4.6782 10.84 5.50429H10.8394ZM7.15688 5.50429L6.32134 4.07547H7.84293L8.67847 5.50429H7.15688V5.50429ZM5.78479 4.09793L6.60734 5.50429H4.15979C4.38138 4.77097 5.01188 4.21315 5.78479 4.09793V4.09793ZM10.9251 8.91797C10.9251 10.0253 10.0234 10.9271 8.91602 10.9271H6.08261C4.97525 10.9271 4.07411 10.0259 4.07411 8.91797V6.08456C4.07411 6.04911 4.07529 6.01365 4.07706 5.97879H10.9227C10.9245 6.01365 10.9257 6.04911 10.9257 6.08456V8.91797H10.9251Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22249 7.20012L8.5544 7.86608C8.74231 7.96003 8.81794 8.18812 8.72458 8.37544C8.68617 8.45167 8.6259 8.51017 8.5544 8.54562L7.19058 9.22753C7.00267 9.32148 6.77458 9.24526 6.68063 9.05735C6.65344 9.00298 6.64044 8.94448 6.64044 8.88776H6.63867V7.52394C6.63867 7.31358 6.80944 7.14221 7.0204 7.14221C7.09426 7.14221 7.1634 7.16348 7.2219 7.19953L7.22249 7.20012Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22249 7.20012L8.5544 7.86608C8.74231 7.96003 8.81794 8.18812 8.72458 8.37544C8.68617 8.45167 8.6259 8.51017 8.5544 8.54562L7.19058 9.22753C7.00267 9.32148 6.77458 9.24526 6.68063 9.05735C6.65344 9.00298 6.64044 8.94448 6.64044 8.88776H6.63867V7.52394C6.63867 7.31358 6.80944 7.14221 7.0204 7.14221C7.09426 7.14221 7.1634 7.16348 7.2219 7.19953L7.22249 7.20012Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3649_58882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.67197 30.5597) rotate(-76.1253) scale(31.9932 53.1818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12714,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelPostIcon);
export default __webpack_public_path__ + "static/media/reelPostIcon.e27320101e83f58e2e5c1ef181e60df8.svg";
export { ForwardRef as ReactComponent };